import { render, staticRenderFns } from "./invest_bank.vue?vue&type=template&id=30bdbfcf&scoped=true"
import script from "./invest_bank.vue?vue&type=script&lang=js"
export * from "./invest_bank.vue?vue&type=script&lang=js"
import style0 from "./invest_bank.vue?vue&type=style&index=0&id=30bdbfcf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bdbfcf",
  null
  
)

export default component.exports